/** Mirrors the server-side cap in thread-store.ts (saveThread slices to the
 *  last 50 MESSAGES — and one ask can add several, since tool rounds persist
 *  their read/edit pairs). Near the cap the oldest history silently drops, so
 *  the client warns first — that check stays message-count based because the
 *  cap is.
 *
 *  The softer "getting long" nudge is TOKEN based: message count says little
 *  about what the user actually feels (a tool round is tiny, a pasted brief
 *  is huge). It fires when the last reply's BIGGEST SINGLE PROMPT was
 *  TOKEN_WARN+ tokens — i.e. every new ask now re-reads that much history, so
 *  replies are getting slower and pricier. Pass the turn's context figure,
 *  never its round-summed input total (see CommandBar). Falls back to message
 *  count when no usage is known yet (thread just reloaded, nothing sent this
 *  session).
 *
 *  Note the floor under any thread: the system prompt (rules + primitive,
 *  template and visual catalogues) is ~22k tokens before a word of
 *  conversation, so TOKEN_WARN has to sit well clear of it or every second
 *  chat opens on a warning. */
export const THREAD_CAP = 50;
// Local-only fallbacks/thresholds: nothing outside this module needs them.
const MSG_WARN = 40;
const TOKEN_WARN = 50_000;

/** 'ok' | 'warn' | 'critical' — the tone the composer renders its
 *  thread-length notice in. */
export type ThreadLimitTone = 'ok' | 'warn' | 'critical';

export function threadLimitTone(count: number, lastInputTokens: number | null = null): ThreadLimitTone {
  if (count >= THREAD_CAP - 5) return 'critical';
  if (lastInputTokens != null ? lastInputTokens >= TOKEN_WARN : count >= MSG_WARN) return 'warn';
  return 'ok';
}
